import { Navigate } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const PrivateTechnicalRouter = ({ children }) => {
    const token = localStorage.getItem('jwt')

    if (token && token !== 'undefined') {
        let token_decode
        try {
            token_decode = jwtDecode(token)
        } catch (error) {
            console.error("Error decoding token:", error)
            return <Navigate to="/logout"/>
        }

        const hasUserRole = token_decode.rol  === 'technical'
        if (hasUserRole) {
            return children
        } else {
            return <Navigate to="/logout"/>
        }
    } else {
        return <Navigate to="/logout"/>
    }
}

export default PrivateTechnicalRouter